import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsx("svg", Object.assign({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: _jsx("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "#C83131"
      })
    }))
  });
};
export default Component;
